/* eslint-disable react/no-array-index-key */
import Text from '@deprecated-ui/common/Text';
import React from 'react';
import SelectDate from './SelectDate';

interface RenderSelectListProps {
  isSelectDisable: boolean;
  selectValue: any;
  setSelectValue: (val: any) => any;
}

const RenderSelectList = React.memo(
  ({ isSelectDisable, selectValue, setSelectValue }: RenderSelectListProps) => (
    <>
      <SelectDate
        key="Days"
        label="Days"
        disabled={isSelectDisable}
        value={selectValue.Days}
        onChange={(el) => setSelectValue({ Days: el.currentTarget.value })}
      >
        {[...Array(31)].map((_el, i) => (
          <Text as="option" key={i}>
            {i}
          </Text>
        ))}
      </SelectDate>
      <SelectDate
        key="Hours"
        label="Hours"
        disabled={isSelectDisable}
        value={selectValue.Hours}
        onChange={(el) => setSelectValue({ Hours: el.currentTarget.value })}
      >
        {[...Array(24)].map((_el, i) => (
          <Text as="option" key={i}>
            {i}
          </Text>
        ))}
      </SelectDate>
      <SelectDate
        key="Mins"
        label="Mins"
        disabled={isSelectDisable}
        value={selectValue.Mins}
        onChange={(el) => setSelectValue({ Mins: el.currentTarget.value })}
      >
        {[...Array(60)].map((_el, i) => (
          <Text as="option" key={i}>
            {i}
          </Text>
        ))}
      </SelectDate>
    </>
  ),
);

export default RenderSelectList;
